import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  createLoanGridElementsWithRenderer,
  createMoneyLoanGridElements,
  RightAlignedDiv,
  createRateLoanGridElements,
  createPeriodLoanGridElements,
  QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';

class Covenants extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }
  renderDscr = (loan) => {
    if(!loan["covenantsDscrStabilized"] && !loan["covenantsDscrAsIs"])
      return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);
    let dscr = loan["covenantsDscrStabilized"];
    if(!dscr) dscr = loan["covenantsDscrAsIs"];
    return dscr.toFixed(2) + 'x';
  }
  render() {
    const { loans, isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("DSCR")}
            {expanded && createLoanGridElementsWithRenderer(loans, this.renderDscr, '\u2014', isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">            
            {createLoanGridLabel("Debt Yield")}
            {createRateLoanGridElements(loans, 'covenantsDebtYieldStabilized', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("LTV")}
            {createRateLoanGridElements(loans, 'covenantsLtvStabilized', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("LTC")}
            {createRateLoanGridElements(loans, 'covenantsLtc', isCombined)}
            
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default Covenants;